import { cn } from '../utils/cn'
import { resolveStatusVisual } from '../utils/statusVisuals'
import { ResolvedIcon, type IconOverrideMap } from '../utils/iconRegistry'

export interface StatusBadgeProps {
  status: string
  className?: string
  iconOverrides?: IconOverrideMap
}

const TONE_CLASS_MAP = {
  success: 'bg-aera-greenlight text-aera-green',
  warning: 'bg-aera-warmcream text-aera-amberdark',
  danger: 'bg-aera-redlight text-aera-red',
  inverse: 'bg-aera-redlight text-aera-red',
  neutral: 'bg-aera-lightgray text-aera-charcoal',
}

export function StatusBadge({ status, className, iconOverrides }: StatusBadgeProps) {
  const { iconKey, tone, label } = resolveStatusVisual(status)

  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-[11px] leading-4 font-bold whitespace-nowrap tracking-tight align-middle',
        TONE_CLASS_MAP[tone],
        className
      )}
    >
      <ResolvedIcon
        iconKey={iconKey}
        overrides={iconOverrides}
        className="h-3.5 w-3.5 shrink-0"
      />
      <span>{label}</span>
    </span>
  )
}
